"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SystemIcon = function SystemIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "32",
    height: "33",
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "16",
    cy: "16.6509",
    r: "16",
    fill: "#677791",
    fillOpacity: "0.3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.0431 22.7716L9.5272 24.8866C9.4361 24.9631 9.32502 25.0121 9.20703 25.0277C9.08904 25.0434 8.96904 25.025 8.86115 24.9747C8.75326 24.9245 8.66196 24.8444 8.59799 24.7441C8.53401 24.6437 8.50003 24.5272 8.50003 24.4081V12C8.50003 11.8343 8.56588 11.6753 8.68309 11.5581C8.8003 11.4409 8.95927 11.375 9.12503 11.375H22.875C23.0408 11.375 23.1998 11.4409 23.317 11.5581C23.4342 11.6753 23.5 11.8343 23.5 12V22C23.5 22.1658 23.4342 22.3248 23.317 22.442C23.1998 22.5592 23.0408 22.625 22.875 22.625H12.4452C12.2981 22.625 12.1557 22.6769 12.0431 22.7716Z",
    stroke: "#677791",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.2499 17.9375C12.7677 17.9375 13.1874 17.5178 13.1874 17C13.1874 16.4822 12.7677 16.0625 12.2499 16.0625C11.7322 16.0625 11.3124 16.4822 11.3124 17C11.3124 17.5178 11.7322 17.9375 12.2499 17.9375Z",
    fill: "black"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 17.9375C16.5178 17.9375 16.9375 17.5178 16.9375 17C16.9375 16.4822 16.5178 16.0625 16 16.0625C15.4823 16.0625 15.0625 16.4822 15.0625 17C15.0625 17.5178 15.4823 17.9375 16 17.9375Z",
    fill: "black"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.7502 17.9375C20.2679 17.9375 20.6877 17.5178 20.6877 17C20.6877 16.4822 20.2679 16.0625 19.7502 16.0625C19.2324 16.0625 18.8127 16.4822 18.8127 17C18.8127 17.5178 19.2324 17.9375 19.7502 17.9375Z",
    fill: "black"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.2499 17.9375C12.7677 17.9375 13.1874 17.5178 13.1874 17C13.1874 16.4822 12.7677 16.0625 12.2499 16.0625C11.7322 16.0625 11.3124 16.4822 11.3124 17C11.3124 17.5178 11.7322 17.9375 12.2499 17.9375Z",
    fill: "#677791"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 17.9375C16.5178 17.9375 16.9375 17.5178 16.9375 17C16.9375 16.4822 16.5178 16.0625 16 16.0625C15.4823 16.0625 15.0625 16.4822 15.0625 17C15.0625 17.5178 15.4823 17.9375 16 17.9375Z",
    fill: "#677791"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.7502 17.9375C20.2679 17.9375 20.6877 17.5178 20.6877 17C20.6877 16.4822 20.2679 16.0625 19.7502 16.0625C19.2324 16.0625 18.8127 16.4822 18.8127 17C18.8127 17.5178 19.2324 17.9375 19.7502 17.9375Z",
    fill: "#677791"
  }));
};

var _default = SystemIcon;
exports["default"] = _default;